import { render, staticRenderFns } from "./all_patients.vue?vue&type=template&id=50515a71&scoped=true&"
import script from "./all_patients.vue?vue&type=script&lang=js&"
export * from "./all_patients.vue?vue&type=script&lang=js&"
import style0 from "./all_patients.vue?vue&type=style&index=0&id=50515a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50515a71",
  null
  
)

export default component.exports